async function devtricker_comment_ajax_like(commentId, likeAction) {

    try {
        const formData = new FormData();

        formData.append('action', 'devtricker_action_comment_like_ajax');
        formData.append('nonce', await devtricker_process_getDevtrickerNonce());
        formData.append('comment_id', commentId);
        formData.append('like_action', likeAction);

        let response = await fetch('/wp-admin/admin-ajax.php', {
            method: 'POST',
            credentials: 'same-origin',
            body: formData
        });

        let result = await response.json();

        if (result.success) {
            devtricker_log(null, devtricker_log_level.INFO, `Comment ${commentId} liked/unliked`);
            return true;
        } else {
            throw new Error('Error when try like a comment - Server respond with error status');
        }
    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR);
        throw error;
    }

}

async function devtricker_ajax_checkIfLikedComments(commentIds) {
    try {
        const params = new URLSearchParams();
        params.append('action', 'devtricker_action_check_user_liked_comments_ajax');
        params.append('comment_ids', commentIds.join(','));

        const url = `/wp-admin/admin-ajax.php?${params.toString()}`;

        console.log("URL: ", url);

        const response = await fetch(url, {
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const result = await response.json();

        if (result.success) {
            devtricker_log(null, devtricker_log_level.INFO, 'Like status successfully retrieved - AJAX');
            return result.data.liked_comments;
        } else {
            throw new Error(result.data?.message || 'Unknown error while checking liked comments.');
        }
    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR);
        throw error;
    }
}